import React from 'react';
import _omit from 'lodash/omit';
import PropTypes from 'prop-types';
// Material UI
import MuiBox from '@material-ui/core/Box';

const Box = ({
  type, withBorder, children, ...otherProps
}) => {
  // Components props
  let boxProps;
  let computedOtherProps;
  if (type === 'primary') {
    boxProps = {
      bgcolor: 'primary.main',
      color: 'primary.contrastText',
    };
    computedOtherProps = { ...otherProps };
  } else if (type === 'highlightable') {
    const { highlighted } = otherProps;
    if (highlighted) {
      boxProps = {
        border: 2,
        borderTop: 0,
        borderLeft: 0,
        borderRight: 0,
        borderColor: 'secondary.main',
      };
    }
    computedOtherProps = _omit(otherProps, 'highlighted');
  } else if (type === 'defaultBackground') {
    boxProps = {
      bgcolor: 'background.default',
    };
    computedOtherProps = { ...otherProps };
  } else if (type === 'tertiary') {
    boxProps = {
      bgcolor: 'tertiary.main',
    };
    computedOtherProps = { ...otherProps };
  }

  if (withBorder) {
    boxProps = {
      ...boxProps,
      border: '1px solid #FAFAFA',
      borderRadius: '4px',
      boxShadow: '0px 0px 3px 1px rgba(167, 171, 171, 0.43)',
    };
  }

  return (
    <MuiBox {...boxProps} {...computedOtherProps}>
      {children}
    </MuiBox>
  );
};

Box.propTypes = {
  type: PropTypes.oneOf(['primary', 'highlightable', 'defaultBackground', 'tertiary']).isRequired,
  children: PropTypes.node.isRequired,
  withBorder: PropTypes.bool,
};

Box.defaultProps = {
  withBorder: false,
};

export default React.memo(Box);



// WEBPACK FOOTER //
// ./components/core/Box.js